/* @ngInject */
const pieceRequest = (
  $q,
  utils,
  valueHandler,
  pieceResource,
  pieceFormat,
  errorHandler,
  labels
) => {
  const self = {}

  self.getBySearch = (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$$piece.getBySearch'
      const data = pieceFormat.server(_data)
      pieceResource.post({ action: 'search', }, { search: data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            pieces: res.data,
            message: labels.piece.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.piece.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.save = (_piece) => {
    return $q((resolve, reject) => {
      const functionName = '$$piece.save'
      const piece = pieceFormat.server(_piece)
      pieceResource.save({}, piece, (res) => {
        if (res && res.success) {
          const response = {
            id: res.data.id,
            message: res.message,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 2) {
            reject(labels.piece.log.save.alreadyExists)
          } else {
            errorHandler.message(res, functionName, _piece)
            reject(labels.piece.log.save.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.saveAll = (_pieces, _wagonId) => {
    const loopPromises = []

    utils.forEach(_pieces, async (piece) => {
      const deferred = $q.defer()
      loopPromises.push(deferred.promise)
      piece.wagonId = _wagonId

      try {
        const response = await self.save(piece)
        deferred.resolve(response)
      } catch (error) {
        deferred.reject(error)
      }
    })
    return $q.all(loopPromises)
  }

  self.update = (_piece) => {
    return $q((resolve, reject) => {
      const functionName = '$$piece.update'
      const piece = pieceFormat.server(_piece)
      pieceResource.update({ action: _piece.id }, piece, (res) => {
        if (res && res.success) {
          const response = {
            message: res.message,
            piece: res.data,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _piece)
          reject(labels.piece.log.update.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.delete = (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$$piece.delete'
      pieceResource.delete({ action: _id, }, (res) => {
        if (res && res.success) {
          resolve(res.message)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _id)
          reject(labels.piece.log.delete.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.getByWagon = async (_wagonId) => {
    return $q((resolve, reject) => {
      const functionName = '$$piece.getByWagon'

      pieceResource.post({ action: 'get-by-wagon', }, { wagonId: _wagonId, }, (res) => {
        if (res && res.success && res.message) {
          resolve(res.data)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _wagonId)
          reject(labels.piece.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}
export default pieceRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/services/request.service.js